import Admins from "../pages/admins/Admins";
import Contact from "../pages/contact/Contact";
import Home from "../pages/home/Home";
import ProjectDetail from "../pages/projects/ProjectDetail";
import Projects from "../pages/projects/Projects";
import SocialLinks from "../pages/sociallinks/SocialLinks";
import Subscribers from "../pages/subscribers/Subscribers";
import Teams from "../pages/teams/Teams";


export const AuthRoutes = [
  // {
  //     path: '/dashboard', component: <DashboardContextProvider> <Dashboard/> </DashboardContextProvider>
  // },
  {
    path: "/home",
    component: <Home />,
  },
  // {
  //   path: "/subscribers",
  //   component: <Subscribers />,
  // },
  // {
  //   path: "/contactus",
  //   component: <Contact />,
  // },
  {
    path: "/projects",
    component: <Projects />,
  },
  {
    path: "/teams",
    component: <Teams />,
  },
  {
    path: "/sociallinks",
    component: <SocialLinks />,
  },
  {
    path: "/admins",
    component: <Admins />,
  },
  {
    path: "/projects/:projectId", 
    component: <ProjectDetail />,
  },
];